import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/cara-front-new/components/pages/blog/blogsContent/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/cara-front-new/components/structure/GeneralContent/index.tsx");
